import { FunctionComponent, useContext } from "react";
import styles from "./ProfileDropdown.module.css";
import images from "../../../../assets/images/index";
import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import ToasterWithMessage from "../../toaster";
import { globalContext } from "../../../../Provider/AppProvider";
import { useMutation } from "@apollo/client";
import { DELETE_DEVICE_TOKEN } from "../../../../features/Auth/api/SignInQuery";
import { roles } from "../../../../helper";


interface Props {
  handleClose: () => void;
  setOpenSuccessDialog: (value: boolean) => void; 
  setOpenDialog: (value: boolean) => void;
}
const ProfileDropdown: FunctionComponent<Props> = ({
  handleClose,
  setOpenSuccessDialog,
  setOpenDialog
}) => {
  const { lockResetIcon, manageAccountIcon, logoutIcon } = images;
  const navigate = useNavigate();
  const {error} = ToasterWithMessage();
  const {globalState} = useContext<any>(globalContext);

  const [deleteDeviceToken] = useMutation(DELETE_DEVICE_TOKEN,{
    fetchPolicy: 'no-cache',
    onCompleted: async () => {
      await signOut().catch(() => error("Something went wrong while logout"))
      localStorage.clear();
      navigate("/login");
    },
    onError: (err) => {
      error(err.message);
    }
  })

  //change password dialog box is opened
  const handleOpenDialog = () => {
    handleClose();
    setOpenDialog(true);
  };

  //navigating to the profile page and the menu will be closed
  const handleclickMyaccount = () => {
    navigate("/profile");
    handleClose();
  };

  //navigating to the login page after sign out
  const handleSignOut = async () => {
    deleteDeviceToken({
      variables: {
        userId: globalState.profile.id ? globalState.profile.id : '',
        deviceToken: globalState.profile.deviceToken ? globalState.profile.deviceToken  : ''
      }
    })
    localStorage.removeItem('x-hasura-role');
  };
  return (
    <div className={styles.profileDropdown}>
      <div className={styles.container}>
        {globalState.profile.userRole !==roles.SUPER_USER && 
          <div className={styles.myAccount} onClick={handleclickMyaccount}>
            <img
              className={styles.sharpOutlineManageAccou}
              alt="AccountIcon"
              src={manageAccountIcon}
            />
            <div className={styles.changePassword}>
              My Account
            </div>
          </div>}
        {(globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)&& 
        <div className={styles.myAccount} data-testid='openDialog' onClick={handleOpenDialog}>
          <img
            className={styles.sharpOutlineManageAccou}
            alt="ResetIcon"
            src={lockResetIcon}
          />
          <div className={styles.changePassword}>
            Change Password
          </div>
        </div>}
        <div className={styles.myAccount} onClick={handleSignOut}>
          <img
            className={styles.sharpOutlineManageAccou}
            alt="logoutIcon"
            src={logoutIcon}
          />
          <div className={styles.changePassword}>
            Sign Out
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDropdown;
